<script>
import api from '@services/api'

export default {
  name: 'WithLayouts',
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      layouts: [],
      isLoading: false,
      error: null,
    }
  },
  watch: {
    'location.id': {
      async handler(val) {
        if (!val) return
        await this.fetchLayouts()
      },
      immediate: true,
    },
  },
  methods: {
    async fetchLayouts() {
      this.isLoading = true
      this.error = null

      try {
        const response = await api.get(`/locations/${this.location.id}/layouts`)
        this.layouts = response.data
      } catch (error) {
        this.error = error
        this.layouts = []
      } finally {
        this.isLoading = false
      }
    },
  },
  render() {
    return this.$scopedSlots.default({
      layouts: this.layouts,
      isLoading: this.isLoading,
      error: this.error,
    })
  },
}
</script>